var _style, _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVto = function SvgVto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    id: "VTO_svg__Livello_1",
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    className: "svgr-icon"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".VTO_svg__st1{fill:#445a64}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "VTO_svg__SVGID_1_",
    d: "M0 0h32v32H0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "VTO_svg__SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#VTO_svg__SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#VTO_svg__SVGID_2_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.9 6.9c.5 0 .9-.4.9-.9V1.9h4.1c.5 0 .9-.4.9-.9s-.4-.9-.9-.9H4v6c0 .4.4.8.9.8M21.9 1.9H26V6c0 .5.4.9.9.9s.9-.4.9-.9V0h-5.9c-.5 0-.9.4-.9.9 0 .6.4 1 .9 1M9.9 29.4H5.8v-4.1c0-.5-.4-.9-.9-.9s-.9.4-.9.9v6h5.9c.5 0 .9-.4.9-.9 0-.6-.4-1-.9-1M26.9 24.4c-.5 0-.9.4-.9.9v4.1h-4.1c-.5 0-.9.4-.9.9s.4.9.9.9h5.9v-6c0-.4-.4-.8-.9-.8M15.9 29c-.8 0-1.4.6-1.4 1.4s.6 1.4 1.4 1.4 1.4-.6 1.4-1.4-.6-1.4-1.4-1.4M2.4 9.2l3.2 9.5h.1L9 9.2h1.9L6.7 20.8h-2L.5 9.2zm8.8 1.5V9.2h9v1.5h-3.6v10.1h-1.7V10.7zM31 15c0 1.2-.2 2.3-.7 3.2s-1.1 1.6-1.9 2.1-1.7.7-2.7.7-1.9-.2-2.7-.7-1.4-1.2-1.9-2.1-.7-2-.7-3.2.2-2.3.7-3.2 1.1-1.6 1.9-2.1c.9-.5 1.8-.7 2.8-.7s1.9.2 2.7.7 1.4 1.2 1.9 2.1c.4.9.6 1.9.6 3.2m-1.7 0c0-.9-.2-1.7-.5-2.4s-.7-1.1-1.3-1.5c-.5-.3-1.1-.5-1.8-.5s-1.3.2-1.8.5-.9.8-1.3 1.5c-.3.6-.5 1.4-.5 2.4 0 .9.2 1.7.5 2.4.3.6.7 1.1 1.3 1.5.5.3 1.1.5 1.8.5s1.3-.2 1.8-.5.9-.8 1.3-1.5c.3-.7.5-1.5.5-2.4",
    className: "VTO_svg__st1"
  }))));
};
export default SvgVto;